import React, { FC, useRef, MouseEvent } from "react";
import { ZIndex } from "@/domains/design/constants";
import { AnimatePresence, motion } from "motion/react";
import styled from "@emotion/styled";

interface InterstitialOverlayProps {
  children?: React.ReactNode;
  delay?: number;
  exitDelay?: number;
  exitDuration?: number;
  isOpen?: boolean;
  handleClose?: () => void;
}

export const InterstitialOverlay: FC<InterstitialOverlayProps> = ({
  children,
  delay,
  exitDelay = 0.08,
  exitDuration = 0.12,
  isOpen = true,
  handleClose,
}) => {
  const overlayRef = useRef<HTMLDivElement>(null);

  const handleClick = (e: MouseEvent) => {
    if (handleClose && e.target === overlayRef.current) {
      handleClose();
    }
  };

  return (
    <AnimatePresence>
      {!!isOpen && (
        <StyledOverlay
          onClick={handleClick}
          ref={overlayRef}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.12, ease: "easeInOut", delay: delay ?? 0 }}
          exit={{
            opacity: 0,
            transition: { delay: exitDelay, duration: exitDuration, ease: "easeInOut" },
          }}
        >
          {children}
        </StyledOverlay>
      )}
    </AnimatePresence>
  );
};

const StyledOverlay = styled(motion.div)`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: ${ZIndex.OnboardingOverlay};
  color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  background: ${({ theme }) => theme.colors.surface.overlay.onboarding};
  backdrop-filter: blur(2px);
`;
